export const PARTNER_CAMPAIGN_BANNER_HEIGHT_CSS_VAR =
  "--partner-campaign-banner-height"
